import { vars } from "@/shared/lib";
import { AnimatePresence, motion, useDragControls } from "framer-motion";
import { ReactNode } from "react";
import { MdClose } from "react-icons/md";
import { modalStyle, overlayStyle } from "./index.css";
import { ModalOption, useModalStore } from "./index.store";

const overlayVariants = {
	initial: { opacity: 0 },
	animate: { opacity: 1 },
	exit: { opacity: 0 }
};

const contentsVariants = {
	initial: { scale: 0.9, opacity: 0, y: 30 },
	animate: { scale: 1, opacity: 1, y: 0 },
	exit: { scale: 0.9, opacity: 0, y: 30 }
};

function Modal() {
	const modals = useModalStore((state) => state.modals);
	const closeModal = useModalStore((state) => state.closeModal);
	const dragControls = useDragControls();

	return (
		<AnimatePresence>
			{modals.map(({ id, children, option }) => (
				<motion.div
					key={id}
					className={overlayStyle}
					variants={overlayVariants}
					initial="initial"
					animate="animate"
					exit="exit"
					transition={{ duration: 0.1 }}
					onClick={() => option?.overlayClose && closeModal(id)}
				>
					<motion.div
						className={modalStyle}
						variants={contentsVariants}
						initial="initial"
						animate="animate"
						exit="exit"
						transition={{ duration: 0.1 }}
						onClick={(e) => e.stopPropagation()}
						drag
						dragElastic={0}
						dragListener={false}
						dragConstraints={false}
						dragControls={dragControls}
						dragTransition={{ power: 0, timeConstant: 0 }}
					>
						{option?.useDragPosition && <motion.div
							onPointerDown={(e) => dragControls.start(e)}
							style={{
								display: "flex",
								flexDirection: "row",
								justifyContent: "flex-end",
								padding: `${vars.size[4]} ${vars.size[8]}`,

								cursor: "move",
								userSelect: "none",
								borderBottom: "1px solid #eee",
								backgroundColor: vars.color.gray[50]
							}}
						>
							<MdClose size={24} style={{ cursor: "pointer" }} onClick={() => closeModal(id)} />
						</motion.div>}

						{children}
					</motion.div>
				</motion.div>
			))}
		</AnimatePresence>
	);
}

Modal.show = (children: ReactNode, option?: ModalOption) => {
	return useModalStore.getState().openModal(children, option);
};

Modal.close = (id: string) => {
	useModalStore.getState().closeModal(id);
};

export default Modal;
